/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SelectLegalDialogMain.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomRadioButtonV2 from "../../../../components/customComponentsV2/common/radioButton/CustomRadioButtonV2";
import { componentStyle } from "../../../../config/appTheme";
import SelectLegalStandard from "./SelectLegalStandard";
import SelectTestCaseDialogMain from "./SelectTestCaseDialogMain";
import CommonBreadcrumbs from "../../../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";
import CustomToolTip from "../../../../components/infoButton/CustomToolTip";

function SelectLegalDialogMain({
  setSelectedLegal,
  displayPageMap,
  displayPage,
  setDisplayPage,
  selectedLegal,
  savedLinkages,
  disableLrRadioButton,
  disabledLegalRequirement = [],
  shouldShowLegalRequirementLinkedInfo = () => false,
  selectedStandard,
  setSelectedStandard,
  selectedChapter,
  setSelectedChapter,
  isAISuggested = false,
  aiRecommendedEntities = [],
}) {
  const [componentType, setComponentType] = useState("all");
  return (
    <Box>
      <Grid container>
        <Grid item sm={12} sx={{ mb: 1 }}>
          <CommonBreadcrumbs
            color={"black"}
            fontSize={12}
            items={[
              ...(displayPage === displayPageMap.ls
                ? [
                    {
                      label: "Select Legal Standard",
                    },
                  ]
                : []),
              ...(displayPage === displayPageMap.lc
                ? [
                    {
                      label: (
                        <CustomToolTip length={10}>
                          {selectedStandard}
                        </CustomToolTip>
                      ),
                      onClick: () => {
                        setDisplayPage(displayPageMap.ls);
                      },
                    },
                    {
                      label: "Select Legal Chapter",
                    },
                  ]
                : []),
              ...(displayPage === displayPageMap.lr
                ? [
                    {
                      label: (
                        <CustomToolTip length={10}>
                          {selectedStandard}
                        </CustomToolTip>
                      ),
                      onClick: () => {
                        setDisplayPage(displayPageMap.ls);
                      },
                    },
                    {
                      label: (
                        <CustomToolTip length={10}>
                          {selectedChapter}
                        </CustomToolTip>
                      ),
                      onClick: () => {
                        setDisplayPage(displayPageMap.lc);
                      },
                    },
                    {
                      label: "Select Legal Requirement",
                    },
                  ]
                : []),
            ]}
          />
        </Grid>

        <Grid item sm={12}>
          <SelectLegalStandard
            disableLrRadioButton={disableLrRadioButton}
            savedLinkages={savedLinkages}
            componentType={componentType}
            setComponentType={setComponentType}
            setSelectedLegal={setSelectedLegal}
            displayPage={displayPage}
            displayPageMap={displayPageMap}
            setDisplayPage={setDisplayPage}
            selectedLegal={selectedLegal}
            disabledLegalRequirement={disabledLegalRequirement}
            shouldShowLegalRequirementLinkedInfo={
              shouldShowLegalRequirementLinkedInfo
            }
            selectedStandard={selectedStandard}
            setSelectedStandard={setSelectedStandard}
            selectedChapter={selectedChapter}
            setSelectedChapter={setSelectedChapter}
            aiRecommendedEntities={aiRecommendedEntities}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default SelectLegalDialogMain;
